import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';
import { twMerge } from 'tailwind-merge';

type ContactListSkeletonProp = {
    count?: number;
    isGrid?: boolean;
    isLarge?: boolean;
    className?: string;
    /** Dark variant, see MessagesPage. Only for the video-call message list -
     *  everywhere else this stays the default light skeleton. */
    videoDark?: boolean;
};

const GenericSkeleton = ({ isLarge = false, isGrid = false }) => (
    <div className={twMerge('flex gap-x-3 p-3', isGrid ? 'flex-col' : '')}>
        <div>{!isGrid ? <Skeleton.Avatar /> : <Skeleton.Image />}</div>
        <div className="w-full">
            <Skeleton.Title className="mb-3 w-full" />

            <Skeleton.Paragraph isLarge={isLarge} />
        </div>
    </div>
);

const GenericListSkeleton = ({
    isGrid,
    count = 4,
    isLarge = false,
    className = '',
    videoDark = false,
}: ContactListSkeletonProp) => (
    <div
        className={twMerge(
            'animate-fade w-full max-w-2xl',
            videoDark ? 'text-gray-600' : 'text-gray-200',
            className,
            isGrid ? 'grid grid-cols-2 gap-3' : '',
        )}
    >
        {Array.from({ length: count }).map((_, index) => (
            <GenericSkeleton key={index} isLarge={isLarge} isGrid={isGrid} />
        ))}
    </div>
);

export default GenericListSkeleton;
